



















import CardGrid from '@/components/home/CardGrid.vue'
import HomeModule from '@/store/home'
import { CardList } from '@/types/Card'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'AllCardsView',
  components: {
    CardGrid
  }
})
export default class AllCardsView extends Vue {
  private get cardList(): CardList {
    return HomeModule.cardlist!
  }

  private async created() {
    if (!this.cardList) {
      await HomeModule.fetchCardlist(this.$route.params.cardListId)
    }

    document.title = `Münsterland.de - ${this.cardList.name}`
  }
}
